
import { axios } from "../axios.instance";

export type AccountVerifyResetPasswordRequest = {
  code: string;
};

export type AccountVerifyResetPasswordResponse = object;

export const accountVerifyResetPassword = async (body: AccountVerifyResetPasswordRequest): Promise<AccountVerifyResetPasswordResponse> => {
  const { data } = await axios.post("auth/account/verify-reset-password", body);

  return data;
};
